module.exports = __webpack_public_path__ + "img/ezeewallet.854ed4a6.svg";